var map = {
	"./people/collection-select": 13364,
	"./people/collection-select.vue": 13364,
	"./people/search": 88197,
	"./people/search-result": 25752,
	"./people/search-result.vue": 25752,
	"./people/search.vue": 88197,
	"./shared/app-header": 23991,
	"./shared/app-header.vue": 23991,
	"./shared/back-to-top": 38202,
	"./shared/back-to-top.vue": 38202,
	"./shared/bio-nav": 57660,
	"./shared/bio-nav.vue": 57660,
	"./shared/bio-tools": 90164,
	"./shared/bio-tools.vue": 90164,
	"./shared/button-clipboard-copy": 3985,
	"./shared/button-clipboard-copy.vue": 3985,
	"./shared/carousel": 79354,
	"./shared/carousel-components/swiper-slide": 29535,
	"./shared/carousel-components/swiper-slide.vue": 29535,
	"./shared/carousel.vue": 79354,
	"./shared/dev-panel": 70725,
	"./shared/dev-panel.vue": 70725,
	"./shared/frontpage-header": 95314,
	"./shared/frontpage-header.vue": 95314,
	"./shared/header-components/menu": 99497,
	"./shared/header-components/menu.vue": 99497,
	"./shared/header-components/search-panel": 41439,
	"./shared/header-components/search-panel.vue": 41439,
	"./shared/header-components/sub-menu": 80630,
	"./shared/header-components/sub-menu.vue": 80630,
	"./shared/leaving-site-modal": 76315,
	"./shared/leaving-site-modal.vue": 76315,
	"./shared/mail-modal": 30910,
	"./shared/mail-modal.vue": 30910,
	"./shared/modal": 61915,
	"./shared/modal.vue": 61915,
	"./shared/office": 11399,
	"./shared/office.vue": 11399,
	"./shared/offices": 86380,
	"./shared/offices-dropdown": 19415,
	"./shared/offices-dropdown.vue": 19415,
	"./shared/offices.vue": 86380,
	"./shared/page-nav": 17708,
	"./shared/page-nav.vue": 17708,
	"./shared/page-tools": 42840,
	"./shared/page-tools.vue": 42840,
	"./shared/search-form": 67128,
	"./shared/search-form.vue": 67128,
	"./shared/show-more": 57542,
	"./shared/show-more.vue": 57542,
	"./shared/sketch": 89907,
	"./shared/sketch.js": 89907,
	"./shared/state": 29671,
	"./shared/state.js": 29671,
	"./shared/tab": 72119,
	"./shared/tab.vue": 72119,
	"./shared/tabs": 12025,
	"./shared/tabs.vue": 12025,
	"./svg-components/close-circle": 29108,
	"./svg-components/close-circle.vue": 29108,
	"./svg-components/close-solid": 26432,
	"./svg-components/close-solid.vue": 26432,
	"./svg-components/facebook": 53253,
	"./svg-components/facebook.vue": 53253,
	"./svg-components/linked-in": 53629,
	"./svg-components/linked-in.vue": 53629,
	"./svg-components/mail": 46574,
	"./svg-components/mail.vue": 46574,
	"./svg-components/share": 72481,
	"./svg-components/share.vue": 72481,
	"./svg-components/twitter-x": 66918,
	"./svg-components/twitter-x.vue": 66918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13728;